<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="角色名/昵称" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button type="primary"size="small" @click="addRoleModal=true">添加角色</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px"></Page>
      </div>
    </Row>

    <!-- 添加角色Modal -->
    <!--<Modal-->
      <!--v-model="addRoleModal"-->
      <!--title="添加角色"-->
      <!--@on-ok="addRoleModal_ok">-->
      <!--<p>角色名：<Input v-model="addRole_Name" placeholder="请输入角色名......"></Input>-->
        <!--<br></p>-->
      <!--<p>昵称：<Input v-model="addRole_NickName" placeholder="请输入昵称......"></Input>-->
        <!--<br></p>-->
      <!--<p>描述：<Input v-model="addRole_Description" placeholder="请输入描述......"></Input>-->
        <!--<br></p>-->
    <!--</Modal>-->

    <set-permission-modal1 v-model="setPermissionsModal" :initValue="setPermissionsRoleId"></set-permission-modal1>
    <add-role-modal v-model="addRoleModal" @on-success="onSuccess"></add-role-modal>
    <role-detail-modal v-model="roleDetailModal" :initValue="roleDetailId" @on-success="onModifySuccess"></role-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '../../store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import SetPermissionModal1 from '@/view/acl/components/set-permission-modal1'
import AddRoleModal from '@/view/acl/components/add-role-modal'
import RoleDetailModal from '@/view/acl/components/role-detail-modal'

export default {
  name: 'roles',
  components: {
    SetPermissionModal1,
    AddRoleModal,
    RoleDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 添加角色Modal
      addRoleModal: false,

      // 设置权限
      setPermissionsRoleId: null,
      setPermissionsModal: false,

      // 详细信息
      roleDetailModal: false,
      roleDetailId: null,

      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      keywordFilter: null,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '角色名',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          minWidth: 200
        },
        {
          title: '昵称',
          resizable: true,
          key: 'nickName',
          ellipsis: 'true',
          minWidth: 200
        },
        {
          title: '状态',
          resizable: true,
          ellipsis: 'true',
          minWidth: 120,
          filters: [
            {
              label: '冻结',
              value: 1
            },
            {
              label: '正常',
              value: 2
            }
          ],
          filterMultiple: false,
          filterMethod (value, row) {
            if (value === 1) {
              return row.deleted === true
            } else if (value === 2) {
              return row.deleted === false
            }
          },
          render: (h, params) => {
            const task_status = params.row.deleted
            if (task_status === false) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'green'
                  }
                }, '正常')
              ])
            } else if (task_status === true) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'red'
                  }
                }, '冻结')
              ])
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 200,
          render: (h, params) => {
            const task_status = params.row.deleted
            if (task_status === false) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.setPermissionsRoleId = params.row.id
                      this.setPermissionsModal = true
                    }
                  }
                }, '设置权限'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.roleDetailId = params.row.id
                      this.roleDetailModal = true
                    }
                  }
                }, '详细信息')
              ])
            } else if (task_status === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onActiveBtnClick(params.row.id)
                    }
                  }
                }, '激活')
              ])
            }
          }// render
        }// {
      ]// cloumn
    }// return
  }, // data
  methods: {
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    addRoleModal_ok () {
      this.$Modal.confirm({
        title: '确认添加角色',
        content: '<p>确认添加此角色</p>',
        onOk: () => {
          store.dispatch('RoleServ_AddObj', {
            params: {
              name: this.addRole_Name,
              nickName: this.addRole_NickName,
              description: this.addRole_Description
            }
          }).then(() => {
            this.refreshPage(this.pageFilter)
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let sortParam = null

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      store.dispatch('RoleServ_GetPage', {
        params: null,
        urlparams: {
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_Role_GetPageResult) {
        return store.getters.get_Role_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_Role_GetPageResult) {
        return store.getters.get_Role_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_Role_GetPageResult) {
        return store.getters.get_Role_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 150
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
